import React, { ReactElement } from "react";
import {
  makeStyles,
  createStyles,
  Dialog,
  DialogContent,
  Button,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import theme from "../../../themes";
import { useEnumStrings } from "../../enumStrings";

export enum ButtonConfigType {
  YesNoConfig = "yesNoConfig",
  OkConfig = "okConfig",
}

export interface YesNoButtonConfig {
  buttonType: ButtonConfigType.YesNoConfig;
  yesButtonAction: () => {};
}

export interface OkButtonConfig {
  buttonType: ButtonConfigType.OkConfig;
  okButtonAction: () => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    dialogPaper: {
      borderRadius: "20px",
      maxWidth: "460px",
      width: "460px",
      overflow: "hidden",
      padding: "0",
    },
    closeButton: {
      position: "absolute",
      top: "14px",
      right: "14px",
      zIndex: 2,
      backgroundColor: "#ED1C24",
      color: "white",
      width: "30px",
      height: "30px",
      padding: 0,
      "&:hover": {
        backgroundColor: "#D41920",
      },
    },
    iconCircle: {
      width: "70px",
      height: "70px",
      borderRadius: "50%",
      backgroundColor: "#ED1C24",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 16px auto",
    },
    title: {
      fontFamily: "DM Sans, sans-serif",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "24px",
      textAlign: "center",
      color: "#000000",
      marginBottom: "16px",
    },
    bodyText: {
      fontFamily: "DM Sans, sans-serif",
      fontSize: "14px",
      lineHeight: "22px",
      color: "#24272C",
      fontWeight: 400,
      marginBottom: "16px",
      textAlign: "left",
    },
    useAlternativeBtn: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFFFFF",
      fontFamily: "DM Sans, sans-serif",
      fontWeight: 700,
      fontSize: "16px",
      borderRadius: "8px",
      padding: "12px 40px",
      textTransform: "uppercase" as const,
      width: "100%",
      marginTop: "8px",
      "&:hover": {
        backgroundColor: "#C99028",
      },
    },
  })
);

const CreateChamberMemberSuggestedAlternativePlusAddressedEmailUsernameModal =
  ({
    open,
    handleClose,
    handleUseSuggestedPlusAddressedAlternative,
    currentAdminConsoleLoginEmail,
    suggestedPlusAddressedEmail,
  }: {
    open: boolean;
    handleClose: () => void;
    handleUseSuggestedPlusAddressedAlternative: () => void;
    currentAdminConsoleLoginEmail: string;
    suggestedPlusAddressedEmail: string;
  }): ReactElement => {
    const classes = useStyles();
    const enumStrings = useEnumStrings();

    // Extract the base email (without the plus part) for the second paragraph
    const baseEmail = currentAdminConsoleLoginEmail;

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.dialogPaper }}
      >
        <IconButton className={classes.closeButton} onClick={handleClose}>
          <CloseIcon style={{ fontSize: "18px" }} />
        </IconButton>
        <DialogContent
          style={{ padding: "30px 30px 24px 30px", textAlign: "center" }}
        >
          <div style={{ marginTop: "10px" }}>
            <div className={classes.iconCircle}>
              <WarningIcon
                style={{ fontSize: "36px", color: "#FFFFFF" }}
              />
            </div>
          </div>
          <div className={classes.title}>
            {enumStrings.createChamberMemberSuggested.title}
          </div>
          <div className={classes.bodyText}>
            {enumStrings.createChamberMemberSuggested.bodyLine1Start}
            {suggestedPlusAddressedEmail}
            {enumStrings.createChamberMemberSuggested.bodyLine1End}
          </div>
          <div className={classes.bodyText}>
            {enumStrings.createChamberMemberSuggested.bodyLine2Start}
            {baseEmail}
            {enumStrings.createChamberMemberSuggested.bodyLine2End}
          </div>
          <div
            className={classes.bodyText}
            dangerouslySetInnerHTML={{
              __html: enumStrings.createChamberMemberSuggested.bodyLine3,
            }}
          />
          <Button
            className={classes.useAlternativeBtn}
            onClick={handleUseSuggestedPlusAddressedAlternative}
            variant="contained"
          >
            {enumStrings.createChamberMemberSuggested.useAlternativeButton}
          </Button>
        </DialogContent>
      </Dialog>
    );
  };

export default CreateChamberMemberSuggestedAlternativePlusAddressedEmailUsernameModal;
